const hideFocusRingsDataAttribute = "data-hidefocusrings";
export {
  hideFocusRingsDataAttribute
};
